import { createContext } from "react";
import { IContextState } from "./ClusterCachedDataContextInterfaces";
import {
    getClusterDetailsClusterStore,
    getDefaultUptimeValuesHMIStore,
    getMachineCentersClusterStore,
    getMQTTBrokerSettingsHMIStore,
} from "utilities/storageUtilities";
import { compressHMIData } from "./helpers";

const clusterDetailsLocalStorage = getClusterDetailsClusterStore();
const machineCenterClustersLocalStorage = getMachineCentersClusterStore();
const defaultUptimeValuesLocalStorage = getDefaultUptimeValuesHMIStore();
const compressedHMIDataLocalStorage = machineCenterClustersLocalStorage
    ? compressHMIData(machineCenterClustersLocalStorage)
    : {};
const mqttBrokerSettingsLocalStorage = getMQTTBrokerSettingsHMIStore();

export const initialStateClusterCachedDataContext: IContextState = {
    store: {
        clusterDetails: clusterDetailsLocalStorage,
        machineCentersCluster: machineCenterClustersLocalStorage || [],
        apolloQueryError: undefined,
        lastUpdated: new Date(),
        defaultUptimeValues: defaultUptimeValuesLocalStorage,
        compressedHMIData: compressedHMIDataLocalStorage,
        mqttBrokerSettings: mqttBrokerSettingsLocalStorage || [],
    },
    dispatch: {
        GetClusterData: async (cluster_id: number, login?: boolean) => {},
        resetClusterStore: () => {},
        reorderMachineCentersCluster: (orderedMachineCenterIds: number[]) => {},
    },
};

export const ClusterCachedDataContext = createContext(initialStateClusterCachedDataContext);
